import React, { useState } from "react"
import { useTheme } from "@emotion/react"
import moment from "moment"
import { UpcomingAppointmentCarouselStyles } from "./UpcomingAppointmentCarouselStyles"
import { Button } from "@mui/material"
import { IAppointmentDetail } from "../../core/services/models/AppointmentDetail"
import { styles } from "../../resources/styles/Styles"
import "./UpcomingAppointmentCarousel.scss";
function UpcomingAppointmentCarousel({
  upcomingAppointments,
  onCancel,
  onReschedule,
  displayActionButtons,
}: any) {
  const theme = useTheme()
  const globalStyles = styles(theme)
  const classes = UpcomingAppointmentCarouselStyles(theme)

  const [upcomingAppointmentInView, updateUpcomingAppointmentInView] = useState(
    0
  )

  function onLeftArrowClick() {
    let temp = upcomingAppointmentInView
    if (temp - 1 > 0) {
      temp = temp - 1
      updateUpcomingAppointmentInView(temp)
    } else {
      updateUpcomingAppointmentInView(upcomingAppointments?.length - 1)
    }
  }

  function onRightArrowClick() {
    let temp = upcomingAppointmentInView
    if (temp + 1 < upcomingAppointments?.length) {
      temp = temp + 1
      updateUpcomingAppointmentInView(temp)
    } else {
      updateUpcomingAppointmentInView(0)
    }
  }

  function renderUpcomingAppointments() {
    return (
      <div
        className="appointmentCard  pt14 fullHeight"
      >
        <div className="titleName">Upcoming Appointments</div>

        {upcomingAppointments && upcomingAppointments?.length > 0 ? (
          <>
            <div
              className="justifySpaceBetween pt16"
            >
              <div className={`col-md-1 p-0 text-center`}>
                <img
                  id="pointer"
                  className="carousel_left"
                  alt="carouselLeftIcon"
                  src={"../../../assets/images/carouselLeftIcon.svg"}
                  onClick={() => onLeftArrowClick()}
                />
              </div>
              {upcomingAppointments &&
                upcomingAppointments[upcomingAppointmentInView] &&
                renderUpcomingAppointmentCard(
                  upcomingAppointments[upcomingAppointmentInView]
                )}
              <div className={`col-md-1 p-0 text-center`}>
                <img
                  className="carousel_right"
                  id="pointer"
                  alt="carouselRightIcon"
                  src={"../../../assets/images/carouselRightIcon.svg"}
                  onClick={() => onRightArrowClick()}
                />
              </div>
            </div>
            {console.log(upcomingAppointments[0]?.status, "upcomingAppointments")}
            {displayActionButtons && (
              <div className="pt16 d-flex justify-content-center">
                {upcomingAppointments?.engageTime === null || upcomingAppointments[0]?.status === "ONGOING" ? "" : <><Button
                  variant="outlined"
                  className={`${classes.cancelButton}`}
                  onClick={() => onCancel(upcomingAppointments[upcomingAppointmentInView])}
                >
                  Cancel
                </Button><Button
                  variant="contained"
                  className={`${classes.rescheduleButton}`}
                  onClick={() => onReschedule(
                    upcomingAppointments[upcomingAppointmentInView]
                  )}
                >
                    Reschedule
                  </Button></>}

              </div>
            )}
          </>
        ) : (
          <div className={classes.noDataState}>No upcoming appointments.</div>
        )}
      </div>
    )
  }

  function renderUpcomingAppointmentCard(
    eachUpcomingAppointment: IAppointmentDetail
  ) {
    return (
      <div className="appointmentCardContent col-md-10">
        <table className="appointmentTable col-md-12">
          <tbody>
            <tr>
              <td className="appointmentTableData">
                < div className="appointmentCardTitle"
                >
                  Location
                </div >
                <div
                  className="appointmentCardValue text-truncate"
                >
                  {eachUpcomingAppointment?.centerName
                    ? eachUpcomingAppointment?.centerName
                    : "-"}
                </div>
              </td >
              <td className="appointmentTableData">
                <div className="appointmentCardTitle">
                  Consultant
                </div>
                <div
                  className="appointmentCardValue"
                  style={{ whiteSpace: "pre-wrap" }}
                >
                  {eachUpcomingAppointment?.consultantName
                    ? eachUpcomingAppointment?.consultantName
                    : "-"}
                </div>
              </td>
            </tr >
            <tr>
              <td className="appointmentTableData">
                <div className="appointmentCardTitle">Date</div>
                <div
                  className="appointmentCardValue  text-truncate"

                >
                  {eachUpcomingAppointment?.scheduleDate
                    ? moment(eachUpcomingAppointment?.scheduleDate).format(
                      "DD-MM-YYYY"
                    )
                    : "-"}
                </div>
              </td>


              <td className="appointmentTableData">
                <div className="appointmentCardTitle">Slot</div>
                <div
                  className="appointmentCardValue  text-truncate"

                >
                  {eachUpcomingAppointment?.allottedBed?.length > 0 ? moment(eachUpcomingAppointment?.allottedBed?.slots[0], "HH:mm").format(
                    "hh:mm A"
                  ) : eachUpcomingAppointment?.slots?.length > 0
                    ? moment(eachUpcomingAppointment?.slots[0], "HH:mm").format(
                      "hh:mm A"
                    )
                    : "-"}
                </div>
              </td>
            </tr>
            <tr>
              <td className="appointmentTableData">
                <div className="appointmentCardTitle">Service</div>
                <div
                  className="appointmentCardValue  text-truncate"

                >
                  {eachUpcomingAppointment?.appointmentType
                    ? eachUpcomingAppointment?.appointmentType
                    : "-"}
                </div>
              </td>
              <td className="appointmentTableData">
                <div className="appointmentCardTitle">Type</div>
                <div
                  className="appointmentCardValue  text-truncate"

                >
                  {eachUpcomingAppointment?.patientAppointmentType
                    ? eachUpcomingAppointment?.patientAppointmentType
                    : "-"}
                </div>
              </td>
            </tr>
          </tbody >
        </table >
      </div >
    )
  }

  return renderUpcomingAppointments()
}

export default UpcomingAppointmentCarousel
